export const TOURNAMENT_STATUS_MAP = {
  tournaments: 1,
  live: 3,
  result: 5,
  winnings: 5,
};
